
















































































































import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import { Module, SubscribeAccount, ServiceAccount, FansLevel} from '../models/Fee';

export default Vue.extend({
  mixins: [upgradeVuex],
  data() {
    return {
      Module,
      customerSelcted: false,
      ruleSelcted: false,
      massSelcted: false,
      customerBuy: false,
      ruleBuy: false,
      massBuy: false,
      FansLevel,
      SubscribeAccount,
      ServiceAccount,
      showCustom: true,
      showAll: true,
    };
  },
  watch: {
    'accountState.changeCrmLevelNum'() {
      this.checkShow();
    },
  },
  mounted() {
    this.checkShow();
  },
  methods: {
    selectedModule(module: string) {
      if (this.accountState.crmLevel && !this.accountState.isExpired && this.accountState.crmLevel.modules.indexOf(module) >= 0) {
        if (this.upgrade.modules.indexOf(module) < 0) {
          this.selectModule(module);
        }
      }
      return this.upgrade.modules.indexOf(module) >= 0;
    },
    showServiceAll() {
      if (this.upgrade.isAll) {
        if (this.accountState.crmLevel) {
          return this.account.weixinType === 1 && this.accountState.crmLevel.modules.length === 3;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    checkShow() {
      this.showCustom = !this.accountState.crmLevel || (this.accountState.crmLevel && this.accountState.isExpired);
      if (this.accountState.crmLevel && !this.accountState.isExpired) {
        if (this.account.weixinType === 1 && this.accountState.crmLevel.modules.length !== 3) {
          this.showAll = false;
          this.$store.commit('UPDATE_IS_ALL', false);
        }
        if (this.account.weixinType !== 1 && this.accountState.crmLevel.modules.length !== 2) {
          this.showAll = false;
          this.$store.commit('UPDATE_IS_ALL', false);
        }
      }
    },
    selectModule(type: string) {
      const temp = this.upgrade.modules;
      const index = temp.indexOf(type);
      if (index >= 0) {
        temp.splice(index, 1);
      } else {
        temp.push(type);
      }
      if (temp.length === 3) {
        this.$store.commit('UPDATE_IS_ALL', true);
      }
      this.$store.commit('UPDATE_MODULES', temp);
    },
    modulePrice(moduleN: string) {
      let price = 0;
      let modulePrice: any;
      if(this.account.weixinType === 1) {
        modulePrice = ServiceAccount;
      } else {
        modulePrice = SubscribeAccount;
      }
      switch (moduleN) {
        case Module.Customer:
          switch (this.upgrade.level) {
            case FansLevel.Level1:
              price = modulePrice.Level1.Customer;
              break;
            case FansLevel.Level2:
              price = modulePrice.Level2.Customer;
              break;
            case FansLevel.Level3:
              price = modulePrice.Level3.Customer;
              break;
            default:
              break;
          }
          break;
        case Module.Rule:
          switch (this.upgrade.level) {
            case FansLevel.Level1:
              price = modulePrice.Level1.Rule;
              break;
            case FansLevel.Level2:
              price = modulePrice.Level2.Rule;
              break;
            case FansLevel.Level3:
              price = modulePrice.Level3.Rule;
              break;
            default:
              break;
          }
          break;
        case Module.Mass:
          switch (this.upgrade.level) {
            case FansLevel.Level1:
              price = modulePrice.Level1.Mass;
              break;
            case FansLevel.Level2:
              price = modulePrice.Level2.Mass;
              break;
            case FansLevel.Level3:
              price = modulePrice.Level3.Mass;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      return price;
    },
    changeIsAll(isAll: boolean) {
      this.$store.commit('UPDATE_IS_ALL', isAll);
    },
  },
});
